import { Typography, Stack } from '@mui/material';
import { IconCirclePlus } from '@tabler/icons-react';
import { PermissionScope } from 'types/apps';
import { useTheme } from '@mui/material/styles';
import ClickableMainCard from 'ui-component/cards/ClickableMainCard';
import { useAppAccessContext } from 'contexts/AppAccessContext';
import { actionButtonSpacing } from 'constants/themeConstants';

export default function AddressCard({
  onClick,
  text,
  permissionScope,
  children,
}: {
  onClick: () => void;
  text: string;
  permissionScope?: PermissionScope;
  children: JSX.Element;
}) {
  const theme = useTheme();
  const { isPermissionDisabled } = useAppAccessContext();

  return (
    <ClickableMainCard
      boxShadow
      onClick={() => {
        onClick();
      }}
      disabled={isPermissionDisabled(permissionScope)}
    >
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={actionButtonSpacing}
        sx={{ my: 0 }}
      >
        <IconCirclePlus color={theme.palette.primary.main} size="48px" />
        <Typography variant="caption">{text}</Typography>
      </Stack>
      {children}
    </ClickableMainCard>
  );
}
